import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import FadeLoader from 'react-spinners/FadeLoader';
import ClipLoader from 'react-spinners/ClipLoader';
import SyncLoader from 'react-spinners/SyncLoader';
import ScaleLoader from 'react-spinners/ScaleLoader';
import GridLoader from 'react-spinners/GridLoader';
import RotateLoader from 'react-spinners/RotateLoader';

const useStyles = makeStyles({
  container: {
    position: 'fixed',
    zIndex: 1000,
    width: 'calc(100vw - 288px)',
    height: '100vh',
    top: '0px',
    left: '288px',
    '& > span': {
      position: 'absolute',
      left: '50%',
      top: `50%`,
    },
  },

});
const Loader = (props) => {
  const classes = useStyles();

  const [loaderColor, setLoaderColor] = useState('#2aa465');

  useEffect(() => {
    setLoaderColor(props?.loaderColor || '#2aa465');
  }, [props]);

  const getLoader = loader => {
    if (loader === 'RotateLoader') return <RotateLoader color={loaderColor} loading={props.loading} margin="1px" height="13px" size={20} />;
    else if (loader === 'ClipLoader') return <ClipLoader color={loaderColor} loading={props.loading} margin="1px" height="13px" size={100} />;
    else if (loader === 'SyncLoader') return <SyncLoader color={loaderColor} loading={props.loading} margin="5px" height="13px" size={20} />;
    else if (loader === 'ScaleLoader') return <ScaleLoader color={loaderColor} loading={props.loading} margin="1px" height="30px" size={100} />;
    else if (loader === 'GridLoader') return <GridLoader color={loaderColor} loading={props.loading} margin="1px" height="13px" size={20} />;
    else return <FadeLoader color={loaderColor} loading={props.loading} margin="1px" height="13px" size={100} />;
  };
  return <div className={classes.container} style={{ background: `${props.bg ? props.bg : '#1c1a1aa6'}`, }}>
    <div
      style={{
        position: 'fixed',
        top: '50%',
        left: '50%',
        width: 'max-content',
        height: 'max-content',
      }}
    >
      {getLoader(props?.loader)}
    </div>
  </div>;
};

export default Loader;
